import { ReactNode } from '@tanstack/react-router';
import { cn } from '../../lib/classNameHelpers';

type KbdVariant = 'filled' | 'text';

type KbdProps = {
  children: ReactNode;
  className?: string;
  variant?: KbdVariant;
};

const variantStyles: Record<KbdVariant, string> = {
  text: 'bg-transparent',
  filled: 'bg-backgroundHoverOverlay text-contentSecondary',
};

export const Kbd = ({ children, className, variant = 'filled' }: KbdProps) => (
  <div
    className={cn(
      'h-6 w-fit min-w-6 rounded px-2 py-1 text-center text-xs font-medium',
      variantStyles[variant],
      className
    )}
  >
    {children}
  </div>
);
